/*
  Sticky buy bar (sections/product__buy-bar.liquid)

  Desktop: shows the bar once the real add to cart button has scrolled past the
  top of the viewport. Phone: shows it whenever that button is out of view, also
  while it still sits below the fold on page load. On both it hides again as
  soon as the button is in view or the footer is reached. The button is found by
  the theme's own hook `data-add-to-cart-trigger`, so the bar reacts to the buy
  area itself instead of a fixed scroll distance.

  Dependency free on purpose: jQuery, vendors.js and app.js are deferred in the
  head, none of them exists while a section script runs during parsing.
*/
(function () {
  var BAR_SELECTOR = '[data-buy-bar]';

  // The bar carries an add to cart button of its own in one of its modes, that
  // one must not become the element we watch.
  var TARGET_SELECTOR = '[data-add-to-cart-trigger]:not([data-buy-bar-button])';

  // Every footer layout of the theme renders exactly one <footer> element, so
  // this works no matter which layout the shop uses.
  var FOOTER_SELECTOR = 'footer';

  // Same breakpoint as the mobile layout in the section's CSS
  var MOBILE_QUERY = '(max-width: 798px)';

  function setUpBar(bar) {
    if (bar.getAttribute('data-buy-bar-ready') === 'true') {
      return;
    }

    var target = document.querySelector(TARGET_SELECTOR);

    // No buy area on this page, so there is nothing to react to and the bar
    // stays where it is: hidden.
    if (!target) {
      return;
    }

    bar.setAttribute('data-buy-bar-ready', 'true');

    var jumpButton = bar.querySelector('[data-buy-bar-jump]');

    if (jumpButton) {
      jumpButton.addEventListener('click', function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    var mobile = window.matchMedia(MOBILE_QUERY);

    var isTargetInView = false;
    var isPastTarget = false;
    var isAtFooter = false;

    // Desktop: only while the buy area sits above the viewport, below the fold
    // it is one scroll away anyway. Phone: whenever the button is out of view,
    // there the buy area often starts below the fold. Never over the footer.
    function update() {
      var wantsBar = mobile.matches ? !isTargetInView : isPastTarget;

      bar.classList.toggle('is-visible', wantsBar && !isAtFooter);
    }

    var targetObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          isTargetInView = entry.isIntersecting;

          // boundingClientRect.top < 0 means the button left upwards
          isPastTarget = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        });

        update();
      },
      { threshold: 0 }
    );

    targetObserver.observe(target);

    // Rotating the phone or resizing the window can cross the breakpoint.
    // Safari before 14 only knows addListener.
    if (mobile.addEventListener) {
      mobile.addEventListener('change', update);
    } else if (mobile.addListener) {
      mobile.addListener(update);
    }

    var footer = document.querySelector(FOOTER_SELECTOR);

    // Without a footer only the buy area coming back into view hides the bar
    if (!footer) {
      return;
    }

    var footerObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          isAtFooter = entry.isIntersecting;
        });

        update();
      },
      { threshold: 0 }
    );

    footerObserver.observe(footer);
  }

  function init() {
    var bars = document.querySelectorAll(BAR_SELECTOR);

    Array.prototype.forEach.call(bars, setUpBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: a reloaded section brings a new element, and a selected
  // section should be visible while it is being edited.
  document.addEventListener('shopify:section:load', init);

  document.addEventListener('shopify:section:select', function (event) {
    if (!event.target || !event.target.querySelector) {
      return;
    }

    var bar = event.target.querySelector(BAR_SELECTOR);

    if (bar) {
      bar.classList.add('is-visible');
    }
  });

  // The theme calls into this object for every section whose schema class
  // starts with js. Nothing to do there, the file drives itself.
  window.PXUTheme = window.PXUTheme || {};
  window.PXUTheme.jsBuyBar = window.PXUTheme.jsBuyBar || {
    init: function () {},
    unload: function () {},
  };
})();
